import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import therapistImage from '../assets/profileImg.jpg';
import certImage from '../assets/cert.png';
import badgeImage from '../assets/badge.png';
import road from '../assets/road.jpg';

const services = [
  "Parenting Difficulties",
  "Codependency",
  "Infidelity (Physical or Emotional)",
  "Unmet Relationship Expectations",
  "Communication Issues",
  "Challenging Behavior / Children",
  "Mental / Emotional Disorders",
  "ADHD",
  "Difficulties from Past Trauma",
  "Anxiety",
  "Depression",
  "Difficulty with Forgiveness",
  "Grief / Death / Loss",
  "Drug / Alcohol Abuse",
  "Marriage / Relationship Difficulties",
  "Negative Relationship Patterns",
  "Divorce or Separation",
  "Parent / Child Relationship Issues",
  "Difficulty Adjusting to Life Changes",
];

const Home = () => {
  return (
    <>
      <section
        className="hero-gap"
        style={{ backgroundImage: `url(${road})` }}
        aria-labelledby="hero-heading"
      >
        <div className="hero-gap-overlay">
          <Container className="text-center">
            <h1 id="hero-heading">Welcome to Hope Road Counseling</h1>
            <p className="hero-gap-subtitle">Providing compassionate care for your mental well-being.</p>
          </Container>
        </div>
      </section>

      <section className="content-section" aria-labelledby="about-hope-road-heading">
        <Container>
          <Row className="justify-content-center text-center gy-4">
            <Col lg={8}>
              <h2 id="about-hope-road-heading">About Hope Road</h2>
              <p>
                Hope Road Counseling was founded to be a safe place for healing and growth. Struggling to find answers?
                Know that counseling is often the right step toward a better life and the best version of you.
              </p>
              <p>
                Together, we explore the roadblocks that may be preventing you from living the life you desire and create
                space for clarity, peace, and renewed confidence one step at a time. It is important that you have a safe
                space to truly open up, without any judgement, and it is in this place where healing happens and the
                journey toward clarity begins.
              </p>
              <div className="about-emblems">
                <img
                  src={certImage}
                  alt="Hope Road Counseling certification"
                  className="about-emblem"
                />
                <a
                  href="https://www.psychologytoday.com/us/therapists/hope-road-counseling-sebring-fl/824898"
                  target="_blank"
                  rel="noreferrer"
                  className="about-emblem-link"
                >
                  <img src={badgeImage} alt="Hope Road badge" className="about-emblem" />
                </a>
              </div>
              <div className="about-map">
                <iframe
                  title="Hope Road Counseling location"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3401.21769469316!2d-81.44261952454048!3d27.485488076310467!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88dc57454b255555%3A0xa1de72442b36ba34!2s1570%20Lakeview%20Dr%20Suite%202B%2C%20Sebring%2C%20FL%2033870!5e1!3m2!1sen!2sus!4v1759284293803!5m2!1sen!2sus"
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section
        className="parallax-gap"
        style={{ backgroundImage: `url(${road})` }}
        aria-hidden="true"
      />

      <section className="content-section" aria-labelledby="meet-your-therapist-heading">
        <Container>
          <Row className="align-items-center gy-4">
            <Col md={6}>
              <h2 id="meet-your-therapist-heading">Meet Your Therapist</h2>
              <p>
                Billie Jo Wagner, MSW, LCSW, is the founder of Hope Road Counseling and a Licensed Clinical Social Worker
                dedicated to helping clients reclaim their stories. Trained in trauma-informed and strengths-based
                practices, Billie Jo partners with clients to cultivate resilience, deepen self-understanding, and build
                practical tools for everyday life.
              </p>
              <p>
                With experience across community, faith-based, and private settings, she approaches each session with
                warmth, curiosity, and respect. Whether you prefer in-office or telehealth appointments, Billie Jo
                provides a welcoming space tailored to your needs and pace.
              </p>
            </Col>
            <Col md={6}>
              <div className="therapist-photo-wrapper">
                <img
                  src={therapistImage}
                  alt="Billie Jo Wagner, MSW, LCSW"
                  className="therapist-photo"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section
        className="parallax-gap"
        style={{ backgroundImage: `url(${road})` }}
        aria-hidden="true"
      />

      <section
        className="parallax-section parallax-section-light"
        aria-labelledby="services-heading"
      >
        <div className="parallax-overlay parallax-overlay-light">
          <Container>
            <Row className="align-items-center gy-4">
              <Col md={6}>
                <h2 id="services-heading">Services</h2>
                <ul className="services-list">
                  {services.map((service) => (
                    <li key={service}>{service}</li>
                  ))}
                </ul>
              </Col>
              <Col md={6}>
                <div className="video-wrapper">
                  <iframe width="560" height="315" src="https://www.youtube.com/embed/95ovIJ3dsNk?si=IdGLto6lvnlOiEU1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>
                <p className="mt-3 text-center text-muted">
                  Check out this video, I believe Nadine Burke Harris is spot on!
                </p>
              </Col>
            </Row>
          </Container>
        </div>
      </section>
    </>
  );
};

export default Home;
